import { useCallback } from 'react';
import { issueMessage } from '../../lib/rcu/catalog/issue';
import type { Result } from '../../lib/rcu/result';
import { useToastStore } from '../../stores/toastStore';

/**
 * Reports a command result and says whether it worked, so callers can close a
 * sheet only when something actually changed.
 */
export const useCommandFeedback = (): (<T>(result: Result<T>, successMessage: string) => boolean) => {
  const success = useToastStore((state) => state.success);
  const error = useToastStore((state) => state.error);

  return useCallback(
    <T,>(result: Result<T>, successMessage: string): boolean => {
      if (result.ok) {
        success(successMessage);
        return true;
      }
      error(issueMessage(result.issue));
      return false;
    },
    [success, error],
  );
};

export default useCommandFeedback;
